import Tone from 'tone';
const MAX_CACHE_SIZE = 12;

class EffectFactory {
    constructor() {
        this.nameToEffects = {};
    }

    useEffect(name, fn, engine) {
        if (engine.isOffline) {
            // dont use this in /create
            return fn();
        }
        if (name in this.nameToEffects &&
            this.nameToEffects[name].length > 0) {
            let effect = this.nameToEffects[name].pop();
            return effect;
        }
        return fn();
    }

    get totalEffects() {
        let x = 0;
        for (let name in this.nameToEffects) {
            x += this.nameToEffects[name].length;
        }
        return x;
    }

    releaseEffect(name, effect, engine) {
        if (engine.isOffline) {
            effect.dispose();
            return;
        }
        if (this.totalEffects >= MAX_CACHE_SIZE) {
            // then we dispose one of the old ones
            for (let name in this.nameToEffects) {
                let effect = this.nameToEffects[name][0];
                if (effect) {
                    this.nameToEffects[name] = this.nameToEffects[name].slice(1);
                    effect.dispose(false);
                    break;
                }
            }
        }

        if (!this.nameToEffects[name]) {
            this.nameToEffects[name] = [];
        }
        effect.disconnect();
        this.nameToEffects[name].push(effect);
    }
}

export const effectFactory = new EffectFactory();
